import axios from "axios";

// const
const REDIRECT_TO_ALGORITHM_LIBRARY = "algorithmLibrary/REDIRECT_TO_ALGORITHM_LIBRARY";
const ALGORITHM_LIBRARY_UPDATE_DATA = "algorithmLibrary/ALGORITHM_LIBRARY_UPDATE_DATA";
const ALGORITHM_LIBRARY_STORE_ALGORITHM_TREE = "algorithmLibrary/ALGORITHM_LIBRARY_STORE_ALGORITHM_TREE";
const ALGORITHM_LIBRARY_TOGGLE_LOADING = "algorithmLibrary/ALGORITHM_LIBRARY_TOGGLE_LOADING";

// reducer
export const algorithmLibrary = (state = {
  loading: false,

  algorithmTree: [],
  algorithmId: "",
  searchName: "",
  name: "",
  logo: "",
  developer: "",
  description: "",
  algorithmParameters: [],
}, action) => {
  switch (action.type) {
    case REDIRECT_TO_ALGORITHM_LIBRARY:
      return {
        ...state,
        algorithmId: action.data
      };
    case ALGORITHM_LIBRARY_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case ALGORITHM_LIBRARY_STORE_ALGORITHM_TREE:
      return {
        ...state,
        algorithmTree: action.data,
        algorithmId: "",
        name: "",
        logo: "",
        developer: "",
        description: "",
        algorithmParameters: [],
      };
    case ALGORITHM_LIBRARY_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，传递参数：algorithm.id
 */
export function redirectToAlgorithmLibraryPage(algorithmId) {
  return {
    type: REDIRECT_TO_ALGORITHM_LIBRARY,
    data: algorithmId
  };
}

/**
 * update data based
 */
export const updateAlgorithmLibraryData = (data) => {
  return {
    type: ALGORITHM_LIBRARY_UPDATE_DATA,
    data: data
  }
};

/**
 * get all algorithms
 */
export const getAlgorithmTree = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/getAlgorithmTree?name=", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmTree(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * get all algorithm categories
 */
export const searchAlgorithmTree = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/getAlgorithmTree?name=" + data.searchName, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmTree(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all algorithm categories
 */
export const storeAlgorithmTree = (algorithmTree) => {
  return {
    type: ALGORITHM_LIBRARY_STORE_ALGORITHM_TREE,
    data: algorithmTree
  }
};

/**
 * check application and get versionedApps
 */
export const showAlgorithm = (data) => (dispatch) => {

  let algorithmId = data.algorithmId;
  if (algorithmId !== null && algorithmId !== undefined && algorithmId !== "") {
    dispatch(toggleLoading(true));

    axios.get(`/api-algorithm/algorithms/search/id?id=${algorithmId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data._embedded.algorithms.length > 0) {
          let algorithm = response.data._embedded.algorithms[0];
          dispatch(updateAlgorithmLibraryData({
            name: "algorithmId",
            value: algorithmId
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "name",
            value: algorithm.name
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "developer",
            value: algorithm.createByName
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "logo",
            value: algorithm.logo
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "description",
            value: algorithm.description
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "algorithmParameters",
            value: algorithm.parameters
          }));

          dispatch(toggleLoading(false));
        } else {
          dispatch(updateAlgorithmLibraryData({
            name: "algorithmId",
            value: ""
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "name",
            value: ""
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "developer",
            value: ""
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "logo",
            value: ""
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "description",
            value: ""
          }));
          dispatch(updateAlgorithmLibraryData({
            name: "algorithmParameters",
            value: []
          }));
          dispatch(toggleLoading(false));
        }
      }
    );
  } else {
    dispatch(updateAlgorithmLibraryData({
      name: "name",
      value: ""
    }));
    dispatch(updateAlgorithmLibraryData({
      name: "developer",
      value: ""
    }));
    dispatch(updateAlgorithmLibraryData({
      name: "logo",
      value: ""
    }));
    dispatch(updateAlgorithmLibraryData({
      name: "description",
      value: ""
    }));
    dispatch(updateAlgorithmLibraryData({
      name: "algorithmParameters",
      value: []
    }));
    dispatch(toggleLoading(false));
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: ALGORITHM_LIBRARY_TOGGLE_LOADING,
    data: show
  }
};
